import {Paper as MuiPaper, type PaperProps as MuiPaperProps} from '@mui/material';

export type GreyPaperProps = MuiPaperProps;

/** Grey panel: `grey.50` fill, `grey.100` border, 24px padding, 8px radius. */
export const GreyPaper = ({sx, ...props}: GreyPaperProps) => {
    const sxList = Array.isArray(sx) ? sx : sx ? [sx] : [];

    return (
        <MuiPaper
            elevation={0}
            sx={[{
                bgcolor: 'grey.50',
                border: '1px solid',
                borderColor: 'grey.100',
                padding: '12px 14px',
                borderRadius: '8px',
            }, ...sxList]}
            {...props}
        />
    );
};
